import posthog from 'posthog-js'

export function usePostHog() {
  posthog.init('phc_tNvisNirvXegzornHeFnNRHCsxuLN6QENHFW3VAQGBS', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-05-24',
  })

  return { posthog }
}
